import { DataGridColSettings } from '@/components/DataGrid/utils';

export const addressNoteFormFields = [
  {
    name: 'type',
    type: 'autocomplete',
    label: 'Type',
    rules: {
      required: 'This field is required.',
    },
    styles: {
      xs: 4,
    },
  },
  {
    name: 'comment',
    type: 'text',
    label: <span>Comment</span>,
    rules: {
      required: 'This field is required.',
      minLength: {
        value: 3,
        message: 'Comment should be more than 2 characters.',
      },
      maxLength: {
        value: 500,
        message: 'Comment should be less than 500 characters.',
      },
    },
    styles: {
      xs: 8,
    },
  },
];

export const AddressNoteTableColumns = [
  'Type',
  'Comment',
  'Date and time',
  'Added by',
  '',
];

export const addressNoteDataGridCols: DataGridColSettings[] = [
  {
    field: 'type',
    headerName: 'Type',
    width: 200,
    visible: true,
  },
  {
    field: 'comment',
    headerName: 'Comment',
    visible: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    width: 200,
    visible: true,
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    width: 200,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
